import React from 'react';
import Box from '@material-ui/core/Box';
import Divider from '@material-ui/core/Divider';
import strings from 'strings';
import { FPActionButton } from 'UI/components/atoms';
import SaveButton from 'UI/components/atoms/SaveButton';
import TitleLabel from 'UI/components/atoms/TitleLabel';

import { FiltersList } from '../FiltersList';

import { useFiltersStyles } from './Filters.styled';

export const Filters = React.memo(({ useFiltersFormInstance }) => {
  const classes = useFiltersStyles();
  const {
    uiState,
    formValues,
    hasActiveFilters,
    handleFilterChange,
    handleAdvancedSearch,
    handleClearSearch
  } = useFiltersFormInstance;

  return (
    <Box className={classes.filtersContainer}>
      <Box className={classes.filtersWrapper}>
        <Box className={classes.filtersHeader}>
          <TitleLabel backNavigation text={strings.resumeSearch.title} variant="h6" />
        </Box>
        <Divider />
        <FiltersList formValues={formValues} onFilterChange={handleFilterChange} />
      </Box>
      <Box className={classes.footerButtonsContainer}>
        <SaveButton
          disabled={!hasActiveFilters}
          isSaving={uiState.submitting}
          initialText={strings.resumeSearch.filters.footer.advancedSearch}
          onProgressText={strings.shared.ui.working}
          onClick={handleAdvancedSearch}
          fullWidth
        />
        <FPActionButton
          text={strings.resumeSearch.filters.footer.clearSearch}
          onClick={handleClearSearch}
          variant="outlined"
          fullWidth
        />
      </Box>
    </Box>
  );
});
